<template>
	<div class="redirect-page">
		<transition name="fade">
			<div class="redirect-loader">
				<img src="./../../assets/logos/LineUp_Logo_Animado.gif" alt="LineUp Tickets" />
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		async mounted() {
			const {
				ErrorCod,
				ErrorDsc,
				UsuarioId,
				UsuarioEmail,
				UsuarioPersonaNombre,
				UsuarioPersonaApellido,
				UsuarioPersonaInicial,
				AccessToken,
				// DatosCompletos,
				IsOrganizador,
				Organizaciones,
				// Permisos,

				State,
			} = this.$route.query;

			// if(Permisos){
			// 	Permisos.split(',')
			// }

			if (Number(ErrorCod) !== 0) {
				this.$store.dispatch("showError", ErrorDsc);
				this.$router.push({ name: "login" });
				return;
			}

			let organizaciones = JSON.parse(Organizaciones)

			const usuario = {
				UsuarioId,
				UsuarioEmail,
				UsuarioPersonaNombre,
				UsuarioPersonaApellido,
				UsuarioPersonaInicial,
				AccessToken,
				IsOrganizador,
				// Permisos
				Organizaciones: organizaciones
			};

			let or_ac = null
			if(organizaciones.length > 0){
				or_ac = Number(organizaciones[0].OrganizadorId);
			}

			await this.$store.dispatch("AuthModule/loginAuto", { Usuario: usuario, OrganizadorActivo: or_ac });

			// if (!DatosCompletos) {
			// 	this.$router.push({
			// 		name: "completar-registro",
			// 		params: { state: State },
			// 	});
			// }

			let url = State

			if(url === 'undefined' || url === 'null' || !url){
				url = '/'
			// } else {
				// if(url.substring(0,8) === '/evento/' && url.slice(-9) === '/checkout'){
				// 	await this.crearTransaccion();
				// }
			}

			if (this.$router.currentRoute.name !== url) {
				this.$router.push({ path: url });
			}
		}
	};
</script>

<style lang="scss" scoped>
	.redirect-page {
		width: 100vw;
		height: 100vh;
		@include flex(row, center, center);

		.redirect-loader {
			margin: 0;
			@include flex(row, center, center);
			z-index: 999;
			@include transition(all 0.2s);

			img {
				width: 240px;
				height: auto;
			}
		}
	}
</style>